<template>
  <div>
    <div class="card border-0 shadow-sm" style="border-radius: 14px; background: #ffffff; border: 1.5px solid #e2e8f0 !important; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);">
      <!-- Standard Vertex Header -->
      <div class="card-header bg-white border-0 pt-3 pb-2 px-3 d-flex justify-content-between align-items-start align-items-sm-center flex-wrap gap-2" style="border-bottom: 1px solid #f1f5f9 !important;">
        <div class="d-flex align-items-center gap-2">
          <div class="widget-icon-pill" style="background-color: #d1fae5; color: #10b981; width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; flex-shrink: 0;">
            <i class="fas fa-file-signature"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold" style="color: #1e293b; font-size: 0.875rem;">Policy Acceptance Report</h6>
            <small class="text-muted" style="color: #64748b; font-size: 0.72rem;">Organisation policies compliance</small>
          </div>
        </div>
      </div>

      <div class="card-body p-3">
        <div class="row">
          <div class="col text-center mx-auto" v-if="loading">
            <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
            <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
          </div>

          <div class="table-responsive" v-else>
            <table class="table policy-table mb-0">
              <thead>
                <tr class="policy-table-header">
                  <th scope="col" v-for="header in headers" :key="header.value" :class="header.width">{{ header.text }}</th>
                </tr>
              </thead>

              <tbody v-if="this.pagination.totalItems <= 0">
                <tr>
                  <td colspan="5" class="text-center text-muted py-4">
                    No records to display.
                  </td>
                </tr>
              </tbody>

              <tbody v-else class="align-middle">
                <tr v-for="(item) in items" :key="item.id" class="policy-row">
                  <td class="fw-semibold text-slate">{{ item.user_name }}</td>
                  <td class="text-muted small">{{ item.user_email }}</td>
                  <td class="text-slate">{{ item.training_topic }}</td>
                  <td>
                    <span class="badge bg-light text-secondary border px-2 py-1">{{ item.version == 0 ? '-' : item.version }}</span>
                  </td>
                  <td class="small text-muted">{{ localFormat(item.date_accepted) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Footer Controls: Download on Left, Pagination on Right -->
        <div class="mt-3 pt-3 border-top d-flex align-items-center justify-content-between flex-wrap gap-2" style="border-color: #f1f5f9 !important;">
          <div>
            <button
              :disabled="downloading"
              type="button"
              class="btn-download-pill"
              v-tooltip.top="'Download Policy Acceptance Report (.xlsx)'"
              @click="downloadCSV"
            >
              <div v-if="downloading" class="spinner-border text-primary me-1" role="status" style="height: 12px; width: 12px;">
                <span class="visually-hidden">Loading...</span>
              </div>
              <svg v-if="!downloading" class="download-icon" width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>
              <span class="download-text">Download</span>
            </button>
          </div>

          <div class="d-flex align-items-center gap-3">
            <div class="d-flex align-items-center gap-2">
              <span class="small text-muted">Rows:</span>
              <select
                class="form-select form-select-sm shadow-none rounded-2 border-slate"
                v-model="this.pagination.pageSize"
                style="width: 4.5rem;"
              >
                <option v-for="(item, index) in rowsOptions" :key="index" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>

            <span class="small text-muted">
              {{ paginationLabel }} of {{ this.pagination.totalItems }}
            </span>

            <div class="d-flex align-items-center gap-1">
              <a
                @click="previousPage()"
                class="pagination-arrow"
                :class="{ disabled: this.pagination.page == 1 }"
                :disabled="this.pagination.page == 1"
              >
                <i class="fa fa-chevron-left"></i>
              </a>
              <a
                @click="nextPage()"
                class="pagination-arrow"
                :class="{ disabled: this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0 }"
                :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0"
              >
                <i class="fa fa-chevron-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 <script>
import moment from 'moment';
import * as XLSX from 'xlsx'

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          loading: false,
          btnDownload: "#00A0C1",
          downloading: false,
          headers: [
            { text: "User", value: "user", width: "col-2" },
            { text: "Email", value: "email", width: "col" },
            { text: "Policy Name", value: "policyName", width: "col" },
            { text: "Version", value: "version", width: "col" },
            // { text: "Policy Link", value: "policyLink", width: "col" },
            { text: "Date/Time of Acceptance", value: "date_time", width: "col" },
         ],
          items:[],
          pagination: {
            pageSize: 5,
            page: 1,
            totalItems: 0,
            totalPages: 1,
          },
          rowsOptions: [5,10,15],
          vssWidth: 3000,
      }
    },

    async created() {
      if (!this.showProduct) return
      await this.init()
    },

    methods: {
      async init(){
        this.items = [];
        this.loading = true;

        this.getData()
      },

      getData(){
        let params = {
          limit: this.pagination.pageSize,
          page: this.pagination.page
        }

        if (this.isManager)  params.manager = this.isManager;

        return new Promise((resolve, reject) => {
        this.$axios.get("/orgadmin/trainings/organisations/"+this.organisationID + "/training-policy/table", {params})
        .then(response => {
          if (response.data.success) {
            this.pagination.totalItems = response.data.total
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            this.items = response.data.policies

            this.loading = false
            resolve()
          }
        }).catch(error => {
            this.loading = false
            reject(error)
          })
        })
     },

     async downloadCSV() {
      this.downloading = true;

      if (this.items.length == 0) {
        this.$toast.error('No Policy Acceptance Report to download.')
        this.downloading = false;
        return
      }

      if (this.downloadingSummary)
        return

      let params = {
        limit: -1
      };

      if (this.isManager)  params.manager = this.isManager;

      try {
        let response = await this.$axios.get("/orgadmin/trainings/organisations/" + this.organisationID + "/training-policy/table-download", { params });
        if (response.data.success) {
          let policies = response.data.policies;

          // Prepare data for CSV
          let csvData = this.prepareCSVData(policies);
          this.generateCSV(csvData);

          this.downloading = false;
        }
      } catch (error) {
        console.error("Error downloading CSV:", error);
        this.downloading = false;
      }
    },

    sanitizeSpreadsheetCell(val) {
      if (typeof val !== 'string') return val ?? ''
      if (/^[=+\-@\t\r]/.test(val)) {
        return `'${val}`
      }
      return val
    },

    prepareCSVData(policies) {
      let headers = ["User Name", "User Email", "Policy Name", "Version", "Date Accepted"];
      let csvContent = [headers];

      (policies || []).forEach(policy => {
        csvContent.push([
          this.sanitizeSpreadsheetCell(policy.user_name),
          this.sanitizeSpreadsheetCell(policy.user_email),
          this.sanitizeSpreadsheetCell(policy.training_topic),
          this.sanitizeSpreadsheetCell(policy.version),
          this.localFormat(policy.date_accepted)
        ]);
      });

      return csvContent;
    },

    generateCSV(csvData) {
      const ws = XLSX.utils.aoa_to_sheet(csvData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Policy Breakdown");
      const dateToday = moment().format("YYYYMMDD");
      const fileName = dateToday + "_" + this.formattedOrgName + "_Policy Acceptance Report.xlsx";

      XLSX.writeFile(wb, fileName);
    },

    previousPage() {
      this.pagination.page > 1 ? this.pagination.page -= 1 : ''
    },

    nextPage() {
      this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
    },

    localFormat(date){
      return moment(date).local().format("LLL");
    },

    copyToClipboard(item) {

        const tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = item.policy_link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        if (item.pdf_exists)
          this.$toast.success("Copied link to clipboard.");
        else
          this.$toast.warning("Copied link to clipboard. PDF Policy being replaced");

    },

  },

  computed: {
    paginationLabel() {
      var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
      var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

      return start + " - " + end
    },

    currentPage() {
      return this.pagination.page
    },

    rowsPerPage() {
      return this.pagination.pageSize
    },

    pageSize() {
      return this.pagination.pageSize
    },

    orgName(){
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
    },

    formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },
  },

  watch: {
    currentPage() {
      this.init()
    },

    pageSize() {
      this.pagination.page = 1
      this.init()
    },
  }

  }

 </script>
 <style scoped>
.widget-icon-pill {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.text-slate {
  color: #1e293b;
}

.border-slate {
  border-color: #cbd5e1;
}

.border-top-subtle {
  border-top: 1px solid #f1f5f9;
}

.policy-table-header th {
  background-color: #F4F6F8 !important;
  color: #435666;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 10px 12px;
  border-bottom: 1.5px solid #e2e8f0;
}

.policy-row td {
  padding: 11px 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.8125rem;
}

.policy-row:hover td {
  background-color: #f8fafc;
}

.pagination-arrow {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  color: #475569;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s ease;
  text-decoration: none;
}

.pagination-arrow:hover:not(.disabled) {
  background-color: #f1f5f9;
  color: #0f172a;
  border-color: #cbd5e1;
}

.pagination-arrow.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-download-pill {
  background-color: #ffffff;
  color: #00a0c1;
  border: 1.5px solid #00a0c1;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.btn-download-pill:hover:not(:disabled) {
  background-color: #00a0c1;
  color: #ffffff;
  border-color: #00a0c1;
  box-shadow: 0 2px 6px rgba(0, 160, 193, 0.35);
}

.btn-download-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-download-pill .download-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

.btn-download-pill .download-text {
  font-weight: 700;
  font-size: 13px;
}
</style>
